import { render, staticRenderFns } from "./CollegeDemand.vue?vue&type=template&id=4b564073&scoped=true"
import script from "./CollegeDemand.vue?vue&type=script&lang=js"
export * from "./CollegeDemand.vue?vue&type=script&lang=js"
import style0 from "./CollegeDemand.vue?vue&type=style&index=0&id=4b564073&prod&scoped=true&lang=less"
import style1 from "./CollegeDemand.vue?vue&type=style&index=1&id=4b564073&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b564073",
  null
  
)

export default component.exports